import React, {Fragment} from 'react';
import cx from 'classnames';

import {Text} from '#component/base';
import {formatCurrency} from '#util/formatCurrency';

import {OrderDetailProps} from './OrderDetail.types';

import {orderDetailsBody, orderDetailsHeadings} from './OrderDetail.css';
import {
  orderDetailGridItem,
  orderDetailGridNotUpcomingOrder,
  orderDetailGridUpcomingOrder,
  orderDetailHeaderItem,
  orderDetailHeaderItemFirst,
  orderDetailMobileWrapper,
  orderDetailStickyCost,
} from './OrderDetailFixed.css';

const OrderDetailFixed = ({order, isNotUpcomingOrder = false}: OrderDetailProps) => {
  const items = order?.orderItems.map(item => ({
    productTitle: item.productTitle,
    unitPrice: item.unitPrice,
    quantity: item.quantity,
    status: isNotUpcomingOrder ? item.status : null,
    cost: item.cost,
  }));

  const gridClass = isNotUpcomingOrder
    ? orderDetailGridNotUpcomingOrder
    : orderDetailGridUpcomingOrder;

  return (
    <div className={orderDetailMobileWrapper}>
      <div className={gridClass}>
        <div className={cx(orderDetailHeaderItem, orderDetailHeaderItemFirst)}>
          <Text variant="body" className={orderDetailsHeadings}>
            Order details
          </Text>
        </div>
        <div className={orderDetailHeaderItem}>
          <Text variant="body" className={orderDetailsHeadings}>
            Unit price
          </Text>
        </div>
        <div className={orderDetailHeaderItem}>
          <Text variant="body" className={orderDetailsHeadings}>
            Qty
          </Text>
        </div>
        {isNotUpcomingOrder && (
          <div className={orderDetailHeaderItem}>
            <Text variant="body" className={orderDetailsHeadings}>
              Status
            </Text>
          </div>
        )}
        <div className={cx(orderDetailHeaderItem, orderDetailStickyCost)}>
          <Text variant="body" className={orderDetailsHeadings}>
            Cost
          </Text>
        </div>
        {items?.map((item, idx) => (
          <Fragment key={idx}>
            <div className={orderDetailGridItem}>
              <Text variant="body" className={orderDetailsBody}>
                {item.productTitle}
              </Text>
            </div>
            <div className={orderDetailGridItem}>
              <Text variant="body" className={orderDetailsBody}>
                {formatCurrency('USD', item.unitPrice)}
              </Text>
            </div>
            <div className={orderDetailGridItem}>
              <Text variant="body" className={orderDetailsBody}>
                {item.quantity}
              </Text>
            </div>
            {isNotUpcomingOrder && (
              <div className={orderDetailGridItem}>
                <Text variant="body" className={orderDetailsBody}>
                  {item.status}
                </Text>
              </div>
            )}
            <div className={cx(orderDetailGridItem, orderDetailStickyCost)}>
              <Text variant="body" className={orderDetailsBody}>
                {formatCurrency('USD', item.cost ?? 0)}
              </Text>
            </div>
          </Fragment>
        ))}
      </div>
    </div>
  );
};

export default OrderDetailFixed;
